<template>
  <div v-if="isVisible"
       class="adjustment-indicator"
       :title="$t('indicator-title')"
  >
    <icon name="adjust"
          scale="1.75"
    />
  </div>
</template>

<script>
  import icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/adjust';
  import { IMAGE_ENHANCEMENTS } from './consts';

  export default {
    name: 'AdjustmentIndicator',
    components: {
      icon
    },
    i18nOptions: {
      keyPrefix: 'uScope.extensions.image-adjust'
    },
    props: {
      viewportId: {
        type: String,
        required: true
      },
      store: {
        type: Object,
        required: true
      }
    },
    computed: {
      isVisible () {
        const { brightness, contrast, gamma } = this.store.states[this.viewportId] || {};

        return !(
          brightness === IMAGE_ENHANCEMENTS.brightness.default &&
          contrast === IMAGE_ENHANCEMENTS.contrast.default &&
          gamma === IMAGE_ENHANCEMENTS.gamma.default
        );
      }
    }
  };
</script>

<style scoped lang="scss">
@import '~lbs-pi-web-styles/lib/variables';

.adjustment-indicator {
  position: relative;
  color: $leica-grey-medium;
}
.caption {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  color: white;
  line-height: 3;
  font-size: 10px;
}
</style>
